import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ApiClient } from "./api/client.js";
import { App } from "./app.js";
import "./styles.css";
import "./account-header.css";
import "./session-page.css";

const rootElement = document.querySelector<HTMLElement>("#root");
if (rootElement === null) {
  throw new Error("Application mount point #root is missing");
}

createRoot(rootElement).render(
  <StrictMode>
    <App api={new ApiClient(import.meta.env.VITE_API_ORIGIN || "/api")} />
  </StrictMode>
);
